import { Component, OnInit, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { UserManagementService } from 'app/services/user-management.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from "../../services/data.service";
import { FrontEndService } from "../../services/front-end.service";
import { LogService } from "app/services/log.service";
import { Location } from '@angular/common';
import { Transition } from '@uirouter/angular';
import { StateService } from '@uirouter/angular';
import { TranslateService } from '@ngx-translate/core';
import { UserProfileService } from "../../services/user-profile.service";

@Component({
    selector: 'app-edit-user',
    templateUrl: './edit-user.component.html',
    styleUrls: ['./edit-user.component.scss']
})
export class EditUserComponent implements OnInit {
    name_error = false;
    role_error = false;
    title_error = false;
    project_error = false;
    username_error = false;
    mobile_number_error = false;
    name = "";
    title = "";
    project = "project";
    password = "";
    role = "no";
    confirm_password = "";
    username = "";
    errorMessage = "";
    mobile_number = "";
    path = "app/users/register/";
    closeResult: string;
    user_id: any;
    is_active: boolean;
    show_all_profiles: boolean;
    projects = [];
    projectOptions: any;
    fullScreenLoader;
    currentUserProfile: any;
    currentUserUsername: any;
    currentUserRole: any;
    userProfileList = [];
    selectedUsers = [];
    dropdownSettings = {};

    // On error, Focus variables
    public  name_focus =  new EventEmitter<boolean>();
    public  title_focus =  new EventEmitter<boolean>();
    public  role_focus =  new EventEmitter<boolean>();

    constructor(
        private user_management_service: UserManagementService,
        private modalService: NgbModal,
        private transition: Transition,
        public dataService: DataService,
        public front_end_service: FrontEndService,
        private _location: Location,
        private stateService: StateService,
        private translate: TranslateService,
        private logService: LogService,
        private cdr: ChangeDetectorRef,
        private userProfileService: UserProfileService
    ) { }

    ngOnInit() {
        this.fullScreenLoader = false;
        this.user_id = this.transition.params().user_id;
        if (localStorage.getItem('currentUserProfile')) {
            this.currentUserProfile = JSON.parse(localStorage.getItem('currentUserProfile'));
            this.currentUserUsername = this.currentUserProfile.username;
            this.currentUserRole = this.currentUserProfile.role;
        }
        this.user_management_service.getUserProfile(this.user_id, (resp) => {
            if(resp.status === true) {
                const data = resp.data;
                if(this.currentUserUsername !== data.username && +this.currentUserRole === 1 && +data.role === 1) {
                    this.stateService.go("Forbidden");
                }
                this.role = data.role;
                this.username = data.username;
                this.name = data.name;
                this.title = data.title;
                this.mobile_number = data.mobile_number;
                this.is_active = data.is_active;
                this.show_all_profiles = data.show_all_profiles;
            }
            this.fullScreenLoader = false;
        });

        this.dropdownSettings = {
            singleSelection: false,
            idField: 'id',
            textField: 'text',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            itemsShowLimit: 2,
            allowSearchFilter: true
        };

        this.getProfiles();

        this.projects = [
            {
                id: '0',
                text: 'Project 1'
            }
        ];

        this.projectOptions = {
            placeholder: 'Please select projects',
            multiple: true
        };
    }

    onSubmit(user) {
        this.logService.printLog('user' + JSON.stringify(user));
        const regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (user["name"].trim() === "" || user["name"] === undefined) {
            this.name = "";
            this.name_error = true;
            this.name_focus.emit(true);
            this.errorMessage = 'enter_your_name.'
        } else if (user["role"] === "no" ) {
            this.hideAllErrors()
            this.role_focus.emit(true);
            this.role_error = true;
            this.errorMessage = 'select_a_role.'
        } else {
            this.hideAllErrors()
            user['title'] = this.title;
            if(user['title'] == 'null') {
                user['title'] = ''
            }
            this.fullScreenLoader = true;
            this.user_management_service.editUserProfile(user, this.user_id, (resp) => {
                this.fullScreenLoader = false;
                if (resp.status === true) {
                    this.front_end_service.addToast(
                        "Success",
                        "user_details_changed",
                        "success"
                    );
                    this.front_end_service.back();
                }
            });
        }
    }

    changeUserRole(e, user_id) {
        const role_id = e.value;
        this.fullScreenLoader = true;
        this.user_management_service.userRole(role_id, user_id, (resp) => {
            setTimeout(() => {
                this.fullScreenLoader = false;
            }, 500);
        });
        this.cdr.detectChanges();
    }

    hideAllErrors() {
        this.project_error = false;
        this.role_error = false;
        this.title_error = false;
        this.username_error = false;
        this.name_error = false;
        this.mobile_number_error = false;
    }

    changeActivationStatus(newStatus) {
        if (newStatus !== this.is_active) {
            this.fullScreenLoader = true;
            this.user_management_service.userVerified(newStatus, this.user_id, (resp) => {
                this.fullScreenLoader = false;
                if (resp.status === true) {
                    this.is_active = newStatus;
                }
            })
        }
    }

    resetPassword(user_id, username) {
        const resetUserData = {
            "id": user_id,
            "username": username
        };

        this.user_management_service.resetPassword(resetUserData, (resp) => {
            if(resp.status) {
                this.front_end_service.addToast(
                    "Success",
                    resp.message,
                    "success"
                );
            }
        });
    }

    deleteUser(user_id) {
        this.front_end_service.confirmAlert('confirm', 'delete_user_confirmation', 'warning', (result) => {
            if (result.value) {
                this.user_management_service.deleteUser(user_id, (resp) => {
                    if(resp.status) {
                        this.front_end_service.addToast(
                            "Success",
                            resp.message,
                            "success"
                        );
                        this.front_end_service.back();
                    }
                });
            }
        });
    }

    getProfiles() {
        this.fullScreenLoader = true;
        this.userProfileService.getProfiles(false, 0, (response) => {
            if (response.status) {
                this.userProfileList = [];
                response.data.forEach((user) => {
                    const userObject = {
                        "id": user.id,
                        "text": user.name
                    };
                    this.userProfileList.push(userObject);
                });
                this.getProfileMap();
            }
            this.fullScreenLoader = false;
        })
    }

    userProfileSelected(event) {
        setTimeout(() => {
            this.assignProfiles();
        }, 100);
    }

    assignProfiles() {
        this.fullScreenLoader = true;

        const profiles = [];

        this.selectedUsers.forEach((userProfile) => {
            profiles.push(userProfile.id);
        });

        const data = {
            "profile_id": profiles,
            "show_all_profiles": this.show_all_profiles,
            "employee_id": this.user_id
        };

        this.userProfileService.assignEmployee(data, (response) => {
            this.fullScreenLoader = false;
        })
    }

    getProfileMap() {
        this.userProfileService.getProfileMap(parseInt(this.user_id, 10), (assignedProfiles) => {
            this.selectedUsers = assignedProfiles;
        });
    }

    changeShowAllProfile(newValue: boolean) {
        if (newValue !== this.show_all_profiles) {
            this.show_all_profiles = newValue;
            this.assignProfiles();
        }
    }
}
